import { yyyymmddGenerator } from "../../Analytics/AnalyticsUtils/yyyymmddGenerator";
import { timeSlicer } from "../../Alerts/timeSlicer";
import { clipResultParam } from "./clipResultParam";

export const generateDownloadStringAILink = (
  userFilters: any,
  groupID?: number | null
) => {
  const convertTimeToUTCFormat = (time: string): string => {
    const [hours, minutes] = time.split(":");
    return encodeURIComponent(`${hours}:${minutes}`);
  };

  const sameDay =
    userFilters.start_date !== null &&
    userFilters.end_date !== null &&
    userFilters.start_date.toString() === userFilters.end_date.toString();

  let searchParamsString = `?username=${
    userFilters.user
  }&start_date=${yyyymmddGenerator(
    userFilters.start_date
  )}&end_date=${yyyymmddGenerator(userFilters.end_date)}`;

  if (sameDay && userFilters.start_time !== null) {
    searchParamsString += `&start_time=${convertTimeToUTCFormat(
      timeSlicer(userFilters.start_time)
    )}`;
  }

  if (sameDay && userFilters.end_time !== null) {
    searchParamsString += `&end_time=${convertTimeToUTCFormat(
      timeSlicer(userFilters.end_time)
    )}`;
  }

  if (userFilters.ground_truth) {
    searchParamsString += `&ground_truth=${userFilters.ground_truth}`;
  }

  searchParamsString += clipResultParam(userFilters.clip_result);

  if (userFilters.site_ids[0]) {
    searchParamsString += `&site_ids=${userFilters.site_ids[0]}`;
  }

  if (userFilters.camera_ids[0]) {
    searchParamsString += `&camera_ids=${userFilters.camera_ids[0]}`;
  }

  // Scope the report to the selected group rather than the whole parent
  // account (username), which can span multiple groups.
  if (groupID) {
    searchParamsString += `&group_id=${groupID}`;
  }

  return searchParamsString;
};
